import { Matter } from './services/matterService'
import { ClientStatus } from './services/clientService'
import { IdentityCheckStatus } from './services/identityCheckService'
import { FeedbackStatus, FeedbackType } from './services/feedbackService'

export interface DisplayStatus {
  label: string
  classes: string
}

// A friendlier, derived status for matters — richer than the raw
// active/closed field, but still computed entirely from data we already
// have (no new backend status to keep in sync). Shared between the Matters
// table and the matter viewer so the two never drift apart.
export const matterDisplayStatus = (m: Matter, completedCount: number, totalCount: number): DisplayStatus => {
  if (m.status === 'closed') {
    return { label: 'Completed', classes: 'bg-secondary/10 text-secondary' }
  }
  if (totalCount > 0 && completedCount === totalCount) {
    return { label: 'Review', classes: 'bg-red-50 text-red-600' }
  }
  if (completedCount > 0) {
    return { label: 'In Progress', classes: 'bg-emerald-100 text-emerald-700' }
  }
  return { label: 'Not Started', classes: 'bg-gray-100 text-gray-600' }
}

export const clientStatusClasses = (status: ClientStatus): string => {
  switch (status) {
    case 'review':
      return 'bg-amber-100 text-amber-700'
    case 'approved':
      return 'bg-emerald-100 text-emerald-700'
    case 'processing':
      return 'bg-blue-100 text-blue-700'
    case 'completed':
      return 'bg-secondary/10 text-secondary'
    default:
      return 'bg-gray-100 text-gray-600'
  }
}

export const identityCheckStatusClasses = (status: IdentityCheckStatus): string => {
  switch (status) {
    case 'verified':
      return 'bg-emerald-100 text-emerald-700'
    case 'rejected':
      return 'bg-red-100 text-red-700'
    default:
      return 'bg-amber-100 text-amber-700'
  }
}

export const feedbackStatusClasses = (status: FeedbackStatus): string => {
  switch (status) {
    case 'in_progress':
      return 'bg-blue-100 text-blue-700'
    case 'planned':
      return 'bg-amber-100 text-amber-700'
    case 'resolved':
      return 'bg-emerald-100 text-emerald-700'
    case 'wont_fix':
      return 'bg-gray-100 text-gray-500'
    default:
      return 'bg-gray-100 text-gray-600'
  }
}

export const FEEDBACK_TYPE_LABELS: Record<FeedbackType, string> = {
  bug: 'Bug',
  feature: 'Feature request',
  feedback: 'Feedback',
}

export const FEEDBACK_STATUS_LABELS: Record<FeedbackStatus, string> = {
  new: 'New',
  in_progress: 'In progress',
  planned: 'Planned',
  resolved: 'Resolved',
  wont_fix: "Won't fix",
}
